export default __webpack_public_path__ + "static/media/500.ac885b5a.svg";